import config from '../config';

const psf = 'limit=:limit&page=:page&order_by=:sorting';
const targetGroupBranchesInclude = config['app.system.branch_type'] === 'CUSTOM' ? 'branches' : 'classificationCodes';
const visitBranchesInclude = config['app.system.branch_type'] === 'CUSTOM' ? 'company.classificationCodes.branches' : 'company.classificationCodes';
const companyBranchesInclude = config['app.system.branch_type'] === 'CUSTOM' ? 'classificationCodes.branches' : 'classificationCodes';

export default {
  login: '/OAuthClients/token',
  passwordsRecoverer: '/guest/passwords/recoverer',
  currentUserData: '/current_user\\?includes=projects.modules,hubspotPermissions,client&limit=unlimited&appends=display_timezone,display_datetime_format',
  currentUserRecognitionNotice: '/current_user/recognition_notice',
  ping: '/ping',
  projects: '/client/:clientId/projects\\?includes=modules&limit=unlimited',
  roles: '/roles',
  modules: '/modules',
  forgotPassword: '/guest/passwords/recoverer/request',

  leadScoringList: `/projects/:projectId/lead_scoring/profiles\\?${psf}&includes=related_to,hubspotTaskOwner`,
  leadScoringItem: '/projects/:projectId/lead_scoring/profiles/:id\\?includes=scoringAttributes,scoringAttributes.values,hubspotTaskOwner',
  leadScoringCreate: '/projects/:projectId/lead_scoring/profiles',
  leadScoringUpdate: '/projects/:projectId/lead_scoring/profiles/:id',
  leadScoringRemove: '/projects/:projectId/lead_scoring/profiles/:id',
  leadScoringTest: '/projects/:projectId/lead_scoring/filters?includes=:includes&limit=:limit?&order_by=:orderColumn,:orderDirection',

  leadContactCurrentBudget: '/client/:clientId/lead_contacts/current_budget',
  leadContactPeopleList: '/client/:clientId/lead_contacts/people_search',
  leadContactCompanyList: '/client/:clientId/lead_contacts/organizations_search',

  pageGroupsList: '/projects/:projectId/page_groups\\?limit=unlimited',
  pageGroupsListPsf: `/projects/:projectId/page_groups\\?${psf}`,
  pageGroupsItem: '/projects/:projectId/page_groups/:id\\?includes=urlPatterns',
  pageGroupsCreate: '/projects/:projectId/page_groups',
  pageGroupsUpdate: '/projects/:projectId/page_groups/:id',
  pageGroupsRemove: '/projects/:projectId/page_groups/:id',

  categoryItem: '/client/:clientId/target_group_categories/:id',
  categoriesList: '/client/:clientId/target_group_categories\\?limit=unlimited',
  categoriesListFiltered: '/client/:clientId/target_group_categories\\?limit=unlimited',
  categoriesListPaginated: `/client/:clientId/target_group_categories\\?${psf}`,
  categoryCreate: '/client/:clientId/target_group_categories',
  categoryUpdate: '/client/:clientId/target_group_categories/:id',
  categoryRemove: '/client/:clientId/target_group_categories/:id',

  countryRegionsList: '/client/:clientId/country_groups\\?limit=unlimited',
  countryRegionsListPsf: `/client/:clientId/country_groups?${psf}`,
  countryRegionsItem: '/client/:clientId/country_groups/:id\\?includes=countries',
  countryRegionsCreate: '/client/:clientId/country_groups',
  countryRegionsUpdate: '/client/:clientId/country_groups/:id',
  countryRegionsRemove: '/client/:clientId/country_groups/:id',
  usersListPaginated: `/users\\?includes=projects&${psf}`,
  usersList: '/users\\?limit=unlimited',
  usersListFiltered: '/users\\?limit=unlimited',
  userCreate: '/users',
  userUpdate: '/users/:id',
  userPasswordChange: '/users/:id/password',
  userAvatarCreate: '/users/:id/avatar',
  userRemove: '/users/:id',
  userGetInfo: '/users/:id\\?includes=projects',
  userProjectAssign: '/projects/:projectId/users/:userId',
  userEnableTwoFactorAuth: '/two_factor_authenticate/enable',
  userGetTwoFactorQRCode: '/two_factor_authenticate/qr-code',
  userGetTwoFactorSecretKey: '/two_factor_authenticate/secret-key',
  userRegenerateTwoFactorRecoveryCodes: '/two_factor_authenticate/regenerate-recovery-codes',
  userDeleteTwoFactor: '/two_factor_authenticate/disable',
  userDeleteOtherUserTwoFactor: '/two_factor_authenticate/:id/disable',
  enterTwoFactorCode: '/two_factor_authenticate/confirm',
  aiOutreachAgentsList: '/projects/:projectId/ai_outreach_agents\\?limit=unlimited',
  aiOutreachAgentsListPsf: `/projects/:projectId/ai_outreach_agents\\?${psf}`,
  aiOutreachAgentsTestPrompt: '/projects/:projectId/ai_outreach_agents/test_prompt',
  aiOutreachAgentsItem: '/projects/:projectId/ai_outreach_agents/:id',
  aiOutreachAgentsCreate: '/projects/:projectId/ai_outreach_agents',
  aiOutreachAgentsUpdate: '/projects/:projectId/ai_outreach_agents/:id',
  aiOutreachAgentsRemove: '/projects/:projectId/ai_outreach_agents/:id',
  clientsList: '/clients\\?limit=unlimited',
  clientsListPsf: `/clients\\?${psf}`,
  clientsDefault: '/clients/default',
  clientsItem: '/clients/:id',
  clientsUiSettings: '/clients/:id/ui/settings',
  clientsCreate: '/clients',
  clientsUpdate: '/clients/:id',
  clientsDelete: '/clients/:id',
  clientsRecognitionUsages: '/clients/:id/recognition_usages',
  clientPackagesList: '/client_packages\\?limit=unlimited',
  clientPackagesListPsf: `/client_packages\\?${psf}`,
  clientPackagesItem: '/client_packages/:id',
  clientPackagesCreate: '/client_packages',
  clientPackagesUpdate: '/client_packages/:id',
  clientPackagesDelete: '/client_packages/:id',
  branchesList: '/client/:clientId/branches\\?includes=codes&limit=unlimited',
  branchesListFiltered: '/client/:clientId/branches\\?limit=unlimited',
  branchesListPaginated: `/client/:clientId/branches\\?includes=codes&${psf}`,
  branchGet: '/client/:clientId/branches/:id\\?includes=translations,codes',
  branchCreate: '/client/:clientId/branches',
  branchUpdate: '/client/:clientId/branches/:id',
  branchRemove: '/client/:clientId/branches/:id',
  branchReplace: '/client/:clientId/branches/:id/replace_and_delete',
  countryGroupList: '/country_groups',
  countriesList: '/countries\\?limit=unlimited&order_by=name,asc',
  targetGroupsList: `/projects/:projectId/target_groups\\?includes=category,${targetGroupBranchesInclude},companySize,countries,countryGroups,campaigns&${psf}`,
  targetGroupsListFiltered: `/projects/:projectId/target_groups\\?includes=category,${targetGroupBranchesInclude},companySize,countries,countryGroups,campaigns`,
  targetGroupsListForBranch: '/target_groups\\?branch_id=:id',
  targetGroupCreate: '/projects/:projectId/target_groups',
  targetGroupGet: `/projects/:projectId/target_groups/:id\\?includes=category,${targetGroupBranchesInclude},companySize,countries,countryGroups,campaigns,leadMarks`,
  targetGroupUpdate: '/projects/:projectId/target_groups/:id',
  targetGroupDelete: '/projects/:projectId/target_groups/:id',
  targetGroupDuplicate: '/projects/:projectId/target_groups/:id/duplicates',
  kompassBranchesList: '/kompass/classification_codes\\?parent_id=:id\\&limit=unlimited',
  downloadBranchesList: '/kompass/classification_codes_exporter\\?version=:version&locale=:locale',
  classificationCodes2ndLevelSearchByLabel: '/kompass/classification_codes\\?level=2',
  companiesList: `/projects/:projectId/companies\\?includes=hasHubspotTransferClaim,country,leadMarks,${companyBranchesInclude}&${psf}`,
  companiesAttributes: '/projects/:projectId/company_attributes\\?includes=leadMarks&limit=unlimited',
  companiesListPaginated: `/projects/:projectId/company_attributes\\?includes=leadMarks&${psf}`,
  companyDetail: '/projects/:projectId/company_attributes/:companyId\\?includes=leadMarks',
  companyCreate: '/projects/:projectId/company_attributes',
  companyUpdate: '/projects/:projectId/company_attributes/:companyId',
  companyDelete: '/projects/:projectId/company_attributes/:companyId',
  projectsList: '/client/:clientId/projects\\?includes=users,modules&limit=unlimited',
  projectsListPaginated: `/client/:clientId/projects\\?includes=users,modules&${psf}`,
  projectCreate: '/client/:clientId/projects',
  projectUpdate: '/projects/:id',
  projectDetail: '/projects/:id',
  projectDelete: '/projects/:id',

  campaignsListFiltered: `/projects/:projectId/campaigns\\?${psf}`,
  campaignsList: '/projects/:projectId/campaigns',
  campaignItem: '/projects/:projectId/campaigns/:campaignId',
  campaignCreate: '/projects/:projectId/campaigns',
  campaignUpdate: '/projects/:projectId/campaigns/:campaignId',
  campaignRemove: '/projects/:projectId/campaigns/:campaignId',

  leadLabelsList: '/client/:clientId/lead_marks\\?limit=unlimited',
  leadLabelsListFiltered: '/client/:clientId/lead_marks\\?limit=unlimited',
  leadLabelsListPaginated: `/client/:clientId/lead_marks\\?${psf}`,
  leadLabelsDetail: '/client/:clientId/lead_marks/:id\\?includes=translations',
  leadLabelsCreate: '/client/:clientId/lead_marks',
  leadLabelsUpdate: '/client/:clientId/lead_marks/:id',
  leadLabelsDelete: '/client/:clientId/lead_marks/:id',
  leadsVisitsListPaginated: `/projects/:projectId/companies\\?includes=country,${companyBranchesInclude}&${psf}`,
  leadVisitSessionRecording: '/projects/:projectId/recordings/:uuid',
  leadsProjectVisits: `/projects/:projectId/visits/\\?includes=hasHubspotTransferClaim,scoringProfile,privateScoringProfile,privateScore,finalScore,company.leadMarks,company.country,${visitBranchesInclude}&${psf}`,
  leadsVisits: '/projects/:projectId/companies/:companyId/visits\\?limit=:limit&skip=:skip&includes=scoringProfile,privateScoringProfile,privateScore,finalScore',
  leadsLeadDetails: `/projects/:projectId/companies/:leadId/\\?includes=country,leadMarks,${companyBranchesInclude},&appends=returned_visitor,last_referer,social_links`,
  toggleCompanyHidden: '/projects/:projectId/companies/:companyId/hidden',
  simpleLeadsLeadDetails: '/projects/:projectId/companies/:leadId',
  assignLeadMarks: '/projects/:projectId/companies/:leadId/lead_marks',
  startExportLeadCompanies: '/projects/:projectId/export/companies\\?order_by=:sorting',
  startExportLeadVisits: '/projects/:projectId/export/visits\\?order_by=:sorting',
  startImportCompanyAttributesLeadLabels: '/projects/:projectId/imports/company_attribute',

  downloadLeads: '/projects/:projectId/exports/:uuid',
  markISP: '/client/:clientId/feature/company/:id/isp',

  matomoValidateSiteId: '/matomo_validator',
  matomoGetCompanyVisitDetails: '/projects/:projectId/companies/:companyId/visits/:visitId/\\?includes=target_group',

  generateToken: '/projects/:projectId/generate_api_token',
  updateHubspotToken: '/projects/:projectId/hubspot',
  updateVisitWebhookToken: '/projects/:projectId/visit_webhook_token',
  updateMicrosoftOfflineConversionSettingSecret: '/projects/:projectId/microsoft_offline_conversion_setting_secret',
  getMicrosoftAuthorizationUrl: '/projects/:projectId/microsoft_authorization_url',
  storeMicrosoftRefreshToken: '/projects/:projectId/microsoft_refresh_token',
  tokenValidation: '/guest/passwords/tokens/validator',
};



// WEBPACK FOOTER //
// ./src/utils/urls.js